import React, { useState, useEffect, memo } from "react";
import Header from "../../layout/Header";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Paginated from "./Paginated";
import TransactionViewModal from "./TransactionViewModal";
import {
  getTransaction,
  clearTransaction,
} from "../../../../actions/transaction";
import { getVoucherTemplate } from "../../../../components/pages/campaigns/services";
import { getAllTrasaction } from "../../../../actions/auth";
import { decrypt } from "../../../../utils/encodingdecoding";
import { getDisplayDate } from "../../../../utils/helper";
import { COLUMNS, SOBISCO_COLUMNS } from "./column";
import { sobiscoMerchantId } from "../../../../utils";
import moment from "moment";

const StarblazeTransactionList = memo(
  ({ getTransaction, Transaction, clearTransaction }) => {
    const [data, setData] = useState([]);
    const [transactionCount, setTransactionCount] = useState();
    const [valueselect, setValueSelect] = useState("all");
    const [loader, setLoader] = useState(true);
    const [showLogin, setShowLogin] = useState(false);
    const [transactionId, setTransactionId] = useState("");
    const [voucher, setVoucher] = useState([]);
    const [option] = useState([
      { label: "All", value: "all" },
      { label: "Qualified", value: "qualified" },
      { label: "Not Qualified", value: "notQualified" },
    ]);
    let id = localStorage.getItem("Id");
    const [filterOption, setFilterOption] = useState("all");

    const unPeople = (e) => {
      setValueSelect(e.value);
      setFilterOption(e.value);
    };

    const onSubmit = () => {};
    useEffect(() => {
      let tempPageIndex = JSON.parse(localStorage.getItem("TransPageIndex"));
      if (tempPageIndex === 1) {
        fetch();
      }
      // eslint-disable-next-line
    }, []);

    useEffect(() => {
      const ShortData = async () => {
        const tempData = Transaction?.data?.transactions;
        (await tempData) &&
          tempData?.map((val) => {
            val.isQualified =
              val?.transactionDetail?.transactionType === "purchase"
                ? val?.qualifiedCampaign?.length
                  ? "Yes"
                  : "No"
                : "-";
            val.totalAmount = val?.transactionDetail?.totalAmount
              ? val?.transactionDetail?.totalAmount
              : "-";
            val.rewardId = val?.qualifiedCampaign?.length
              ? val?.transactionDetail?.reward_id
              : "-";
            val.transactionType =
              val?.transactionDetail?.bitType?.length > 0
                ? val?.transactionDetail?.bitType
                : val?.transactionDetail?.transactionType === "purchase" &&
                    decrypt(id) === sobiscoMerchantId
                  ? "earned"
                  : val?.transactionDetail?.transactionType;
            var type = "";
            var total = 0;
            val?.qualifiedCampaign?.map((value) => {
              if (value.type === "voucher") {
                total = value.value;
                type = value.type;
              }
            });
            val.netValue = val?.transactionDetail?.orderDetails?.netValue;
            val.billLink = val?.transactionDetail?.billLink;

            const positiveValues = val?.qualifiedCampaign?.filter(
              (item) => item.value > 0,
            );
            const totalPositiveValue = positiveValues?.reduce(
              (acc, curr) => acc + curr.value,
              0,
            );
            voucher?.voucherTemplate?.length &&
              voucher?.voucherTemplate?.map((data) => {
                if (total == data.code) total = data.voucherValue;
              });
            val.earning =
              type === "voucher"
                ? // "Earn voucher worth " + total :
                  "N/A"
                : totalPositiveValue
                  ? totalPositiveValue + " " + "points"
                  : val?.transactionDetail?.values;

            return (
              (val.name = val.customer?.[0]?.name || val.customer?.name),
              (val.mobile =
                val.customer?.[0]?.mobile ||
                val.customer?.mobile ||
                val?.customer?.[0]?.MobileNumber),
              (val.activity = val?.transactionDetail?.activity),
              (val.rewardpoint = val?.transactionDetail?.rewardpoint),
              (val.location = val?.transactionDetail?.location?.address),
              val.transactionId,
              ((val.transactionProcessedDate = getDisplayDate(
                val.transactionProcessedDate,
              )),
              (val.qrcode = "true"),
              (val.action = (
                <Link
                  to=""
                  state={{ transactionId: val.customer.customercode }}
                  onClick={() => handleViewModal(val.transactionId)}
                >
                  <i className="fa-solid fa-eye"></i> View Details
                </Link>
              )))
            );
          });

        if (tempData) {
          await tempData.sort(function (a, b) {
            if (a.transactionProcessedDate === null) {
              return 1;
            } else if (b.transactionProcessedDate === null) {
              return -1;
            }
            const dateA = new Date(a.transactionProcessedDate);
            const dateB = new Date(b.transactionProcessedDate);
            if (dateA < dateB) {
              return 1;
            } else if (dateA > dateB) {
              return -1;
            } else {
              const timeA = dateA.getTime();
              const timeB = dateB.getTime();
              return timeB - timeA;
            }
          });
        }
        tempData?.map((val) => {
          const filteredData =
            filterOption === "all"
              ? tempData
              : tempData?.filter((val) => {
                  if (filterOption === "qualified") {
                    return (
                      val?.transactionDetail?.transactionType === "purchase" &&
                      val?.qualifiedCampaign?.length
                    );
                  } else if (filterOption === "notQualified") {
                    return (
                      val?.transactionDetail?.transactionType === "purchase" &&
                      val?.qualifiedCampaign?.length == 0
                    );
                  }
                  return false;
                });
          setData(filteredData);
        });
      };

      ShortData();
    }, [Transaction, voucher, filterOption]);

    const fetch = async () => {
      setLoader(true);
      await clearTransaction();
      const token = JSON.parse(localStorage.getItem("token_gen"));
      await getTransaction(token?.access_token, id, 1, 50);
      await getVoucherTemplate(token?.access_token).then((res) => {
        setVoucher({ ...voucher, voucherTemplate: res.data });
      });
      setLoader(false);
    };

    const handleViewModal = (data) => {
      setShowLogin(true);
      setTransactionId(data);
    };

    const generateCSV = async () => {
      setLoader(true);

      try {
        const token = JSON.parse(localStorage.getItem("token_gen"));

        if (!token?.access_token || !id) {
          throw new Error("Missing token or ID");
        }
        const response = await getAllTrasaction(
          token?.access_token,
          id,
          1,
          transactionCount,
        );
        const transactions = response?.transactions || [];
        const transformedData = transactions?.map((val) => {
          return {
            name: val.customer?.[0]?.name || val.customer?.name || "N/A",
            mobile:
              val.customer?.[0]?.mobile ||
              val.customer?.mobile ||
              val?.customer?.[0]?.MobileNumber ||
              "N/A",
            activity: val?.transactionDetail?.activity || "N/A",
            rewardpoint: val?.transactionDetail?.rewardpoint ?? "N/A",
            location: val?.transactionDetail?.location?.address || "N/A",
            transactionProcessedDate:
              getDisplayDate(val?.transactionProcessedDate) || "N/A",
          };
        });
        const csvHeaders = [
          "Name",
          "Mobile",
          "Activity",
          "Reward Point",
          "Location",
          "Date",
        ];
        const escapeCsvValue = (value) =>
          `"${String(value ?? "").replace(/"/g, '""')}"`;
        const csvData = [
          csvHeaders,
          ...transformedData?.map((row) => [
            row.name,
            row.mobile,
            row.activity,
            row.rewardpoint,
            row.location,
            row.transactionProcessedDate,
          ]),
        ];
        const csvContent =
          "data:text/csv;charset=utf-8," +
          csvData
            .map((row) => row.map(escapeCsvValue).join(","))
            .join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "report.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error generating CSV:", error.message || error);
      } finally {
        setLoader(false);
      }
    };

    useEffect(() => {
      setTransactionCount(Transaction?.data?.totalCount);
    }, [Transaction]);

    return (
      <>
        <Header name={"Transaction"} />
        {loader && (
          <div className="mainPreloaderMain">
            <div className="mainPreloader">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        )}
        <div className="dashboard__content">
          <div className="container-fluid">
            {showLogin && (
              <TransactionViewModal
                show={showLogin}
                close={() => setShowLogin(false)}
                transactionId={transactionId}
              />
            )}

            <div className="dashboard__transactionsCard">
              <div className="dashboard__header">
                <div className="dashboard__left">
                  <h4 id="transction_list">All Transactions</h4>
                </div>
                <div className="dashboard__right">
                  <button onClick={generateCSV} className="btn btn-default">
                    <i
                      class="fa-solid fa-download"
                      style={{ marginRight: "10px" }}
                    ></i>
                    Download Transaction
                  </button>
                </div>
              </div>
              <div className="dashboard__body">
                <Paginated
                  data={data}
                  columns={
                    decrypt(id) === sobiscoMerchantId
                      ? SOBISCO_COLUMNS
                      : COLUMNS
                  }
                  setLoader={setLoader}
                  loader={loader}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  },
);

const mapStateToProps = (state) => ({
  Transaction: state.Transaction,
});
const mapDispatchToProps = {
  getTransaction,
  clearTransaction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StarblazeTransactionList);
